module.exports = __webpack_public_path__ + "img/ticket-star.a1b6df71.svg";